import React from 'react'
import { useHistory } from 'react-router-dom'

const PrivateRoute = (PrivateComponent) => {
  const Private = (props) => {
    const history = useHistory()
    const token = localStorage.getItem('afr-portale-authorization-token')

    if (!token) history.push('/login')
    return <PrivateComponent {...props} />
  }

  return Private
}

export default PrivateRoute
